/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
const Visible = (el, binding) => el.style.visibility = binding.value ? 'visible' : 'hidden';
export default Visible;
